import React from 'react';
import VideoStage from '../VideoStage';
import { trackEvent } from '../../analytics';
import { editedVideoFilename } from '../../utils/videoFilename';

const EditedResultPanel = ({
    currentProject,
    editedVideoUrl,
    onEditedPlay,
    projectId,
}) => {
    if (!(currentProject.editedVideo && currentProject.editedVideo.status === 'complete')) {
        return null;
    }
    return (
        <div className="pv-full-width" style={{ marginTop: '20px', paddingBottom: '20px' }}>
            {/* No rotation and no rotate control, deliberately, on both counts:
                FFmpeg has already baked the project's rotation into these
                pixels. Turning the frame again would undo it, and offering the
                control here would imply the finished file can be re-oriented
                without a re-render. It gets the same bar as every other player
                so the product has one, not two. */}
            {editedVideoUrl && <VideoStage src={editedVideoUrl} onPlay={onEditedPlay} />}
            {editedVideoUrl && (
                <div className="pv-center-button-container">
                    <button
                        className="btn btn-teal btn-download"
                        onClick={async () => {
                            trackEvent('video_downloaded', { project_id: projectId });
                            try {
                                const response = await fetch(editedVideoUrl);
                                // A 403/404 body is still a body: without this,
                                // an expired or revoked download token would be
                                // saved as a few-hundred-byte XML error named
                                // like the finished video. Fail into the catch
                                // instead, which hands the URL to the browser
                                // and lets IT report the error.
                                if (!response.ok) throw new Error(`download failed: ${response.status}`);
                                const blob = await response.blob();
                                const url = window.URL.createObjectURL(blob);
                                const a = document.createElement('a');
                                a.href = url;
                                // Same grammar as the source download —
                                // `{project} – {capture range} (edited).mp4`.
                                // No coverage rollup is threaded here on
                                // purpose: this panel renders on three
                                // surfaces, only one of which subscribes to
                                // it, and a name that changed depending on
                                // which tab you downloaded from would be
                                // worse than one that leans on the worker's
                                // own compiledFrom snapshot everywhere.
                                a.download = editedVideoFilename(currentProject);
                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);
                                window.URL.revokeObjectURL(url);
                            } catch (err) {
                                console.error('Download failed:', err);
                                window.open(editedVideoUrl, '_blank');
                            }
                        }}
                    >
                        <svg className="download-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                            <polyline points="7 10 12 15 17 10" />
                            <line x1="12" y1="15" x2="12" y2="3" />
                        </svg>
                        Download Edited Video
                    </button>
                </div>
            )}
        </div>
    );
};

export default EditedResultPanel;
